module.exports = __webpack_public_path__ + "static/media/rounded-arrow.a28b0a0f.svg";